import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as heartbeatActions from './heartbeat.actions';

const pulseRate = process.env.PULSE_RATE;

export class HeartbeatComponent extends Component {
  constructor() {
    super();
    this.state = {
      interval: null,
      isActive: true,
      sentKeepAliveLastInterval: false,
    }

    this.handleActivity = this.handleActivity.bind(this);
    this.handleHeartbeat = this.handleHeartbeat.bind(this);
    this.scheduleHeartbeat = this.scheduleHeartbeat.bind(this);
    this.setupActivityTracking = this.setupActivityTracking.bind(this);
    this.cleanupActivityTracking = this.cleanupActivityTracking.bind(this);
  }

  setupActivityTracking() {
    document.addEventListener('mousemove', this.handleActivity);
    document.addEventListener('mousedown', this.handleActivity);
    document.addEventListener('keypress', this.handleActivity);
    document.addEventListener('touchstart', this.handleActivity);
    document.addEventListener('scroll', this.handleActivity);
  }

  cleanupActivityTracking() {
    document.removeEventListener('mousemove', this.handleActivity);
    document.removeEventListener('mousedown', this.handleActivity);
    document.removeEventListener('keypress', this.handleActivity);
    document.removeEventListener('touchstart', this.handleActivity);
    document.removeEventListener('scroll', this.handleActivity);
  }

  handleActivity() {
    this.cleanupActivityTracking();
    if (!this.state.sentKeepAliveLastInterval) {
      this.handleHeartbeat();
    }
    this.setState({
      isActive: true
    });
  }

  sessionIsExpired() {
    const { auth } = this.props;
    const { currentSession } = auth || {};

    // So heartbeat doesn't send keepalive request
    if (!currentSession) {
      return false;
    }

    const SESSION_TIMEOUT_PADDING_MS = 30000;
    const expiresAtUtc = currentSession.session.expiresAtUtc + 'Z';
    return new Date(Date.now()) > new Date(Date.parse(expiresAtUtc) + SESSION_TIMEOUT_PADDING_MS);
  }

  scheduleHeartbeat() {
    var interval = setInterval(() => {
      // If session is expired, send heartbeat to force logout
      if (this.sessionIsExpired()) {
        this.handleHeartbeat();
      }

      if (this.state.isActive) {
        this.handleHeartbeat();
        this.setState({ isActive: false, sentKeepAliveLastInterval: true });
      } else {
        this.setState({ sentKeepAliveLastInterval: false });
      }
      this.setupActivityTracking();

    }, pulseRate);

    this.setState({
      interval
    });
  }

  handleHeartbeat() {
    const { auth, heartbeatActions } = this.props;
    const { isAuthenticated } = auth;
    if (isAuthenticated) {
      heartbeatActions.sendHeartbeat();
    }
  }

  componentDidMount() {
    const { auth } = this.props;
    const { isAuthenticated } = auth;
    if (isAuthenticated) {
      this.setupActivityTracking();
      this.scheduleHeartbeat();
    }
  }

  componentDidUpdate(prevProps) {
    const { auth: prevAuth } = prevProps;
    const { isAuthenticated: wasAuthenticated } = prevAuth;
    const { auth } = this.props;
    const { interval } = this.state;
    const { isAuthenticated } = auth;

    if (wasAuthenticated && !isAuthenticated) {
      this.cleanupActivityTracking();
      clearInterval(interval);
    }
    else if (!wasAuthenticated && isAuthenticated) {
      this.setupActivityTracking();
      this.scheduleHeartbeat();
    }
  }

  componentWillUnmount() {
    const { interval } = this.state;
    if (interval) {
      clearInterval(interval);
    }
    this.cleanupActivityTracking();
  }

  render() {
    return null;
  }
}

HeartbeatComponent.propTypes = {
};

const mapStateToProps = ({ heartbeat, auth }) => {
  return {
    heartbeat,
    auth,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    heartbeatActions: bindActionCreators(heartbeatActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HeartbeatComponent);



// WEBPACK FOOTER //
// src/auth/heartbeat-system/heartbeat.component.js